import { __assign } from "tslib";
import * as React from 'react';
import { setOpacity } from '../../../../utils/colorUtils';
import ColorIndicator from '../ColorIndicator';
import WhiteBackground from '../WhiteBackground';
import TimeRenderer from '../TimeRenderer';
import EventHover from '../EventHover';
import { st, classes } from './Event.st.css';
import MoreOneHourEvent from '../MoreOneHourEvent';
import WixStylesContext from '../../../../context/wixStylesContext';
import { EVENT_BACKGROUND_OPACITY } from '../../../../constants';
var Event = function (_a) {
    var event = _a.event, titleToDisplay = _a.titleToDisplay, ariaLabel = _a.ariaLabel, className = _a.className, isMobile = _a.isMobile;
    var _b = React.useContext(WixStylesContext), isGoogleColor = _b.isGoogleColor, isTimeShown = _b.isTimeShown, eventTitleFont = _b.eventTitleFont, eventTimeFont = _b.eventTimeFont;
    var eventRef = React.useRef(null);
    var lineHeight = 
    //@ts-ignore
    typeof eventTitleFont === 'undefined' || eventTitleFont.size < 16
        ? '16'
        : //@ts-ignore
            eventTitleFont.size;
    var height;
    if (typeof eventTitleFont === 'undefined' ||
        typeof eventTimeFont === 'undefined') {
        height = lineHeight;
    }
    else {
        height =
            //@ts-ignore
            eventTitleFont.size > eventTimeFont.size
                ? //@ts-ignore
                    eventTitleFont.size
                : //@ts-ignore
                    eventTimeFont.size;
    }
    var _c = React.useState('3'), linesNumber = _c[0], setlinesNumber = _c[1];
    React.useEffect(function () {
        if (eventRef && eventRef.current) {
            var lines = ((eventRef.current.clientHeight - height) / height - 1) | 0;
            setlinesNumber((lines < 0 ? 0 : lines) + '');
        }
    }, [eventTitleFont, eventTimeFont, height]);
    var opacity = EVENT_BACKGROUND_OPACITY;
    var backgroundColor = isGoogleColor
        ? setOpacity(opacity, event.extendedProps.googleColor)
        : setOpacity(opacity, event.extendedProps.eventColor);
    var pastEvent = event.extendedProps.pastEvent;
    var titleHeight = 14;
    if (typeof eventTitleFont !== 'undefined') {
        //@ts-ignore
        titleHeight = eventTitleFont.size;
    }
    var oneHourEventWrapper = function () {
        var style = {
            padding: '4px 0 8px 4px',
        };
        if (titleHeight >= 14) {
            style.padding = '4px 0 8px 4px';
        }
        return className === 'OneHourEvent' ? style : '';
    };
    var oneHourEventTitleStyle = function () {
        var style = {
            marginBottom: '2px',
        };
        if (titleHeight >= 14) {
            style.marginBottom = '4px';
        }
        if (linesNumber === '1') {
            style.marginBottom = '2px';
        }
        return style;
    };
    return className !== 'MoreOneHourEvent' ? (React.createElement(React.Fragment, null,
        React.createElement(ColorIndicator, { event: event }),
        React.createElement(WhiteBackground, null,
            React.createElement(EventHover, { event: event, ariaLabel: ariaLabel, isMobile: isMobile }),
            React.createElement("div", { ref: eventRef, className: classes["".concat(className, "Wrapper")], style: __assign(__assign({}, oneHourEventWrapper()), { backgroundColor: backgroundColor }) },
                React.createElement("div", { className: classes.Content },
                    className === 'OneHourEvent' ? (React.createElement("p", { className: st(classes.Title, {
                            pastEvent: pastEvent,
                            isMobile: isMobile,
                        }), style: __assign({}, oneHourEventTitleStyle()) },
                        titleToDisplay,
                        className !== 'OneHourEvent' &&
                            isTimeShown &&
                            !isMobile &&
                            ', ')) : (React.createElement("span", { className: st(classes.Title, {
                            pastEvent: pastEvent,
                            isMobile: isMobile,
                        }) },
                        titleToDisplay,
                        className !== 'OneHourEvent' &&
                            isTimeShown &&
                            !isMobile &&
                            ', ')),
                    isMobile || React.createElement(TimeRenderer, { event: event, lessOneHour: true })))))) : (React.createElement(MoreOneHourEvent, { event: event, titleToDisplay: titleToDisplay, ariaLabel: ariaLabel, isMobile: isMobile }));
};
export default Event;
//# sourceMappingURL=Event.js.map